import classNames from "classnames";
import React from "react";
import { ROOT } from "../data-hooks";
import styles from "../statics/styles/divider-viewer.rtlignore-scss";
const DividerViewer = ({ node }) => {
  const { lineStyle, width, alignment } = node.dividerData || {};
  const lineStyleAsLowerCase = lineStyle?.toLowerCase();
  const linesPropsArr = getLines(lineStyleAsLowerCase);
  const className = classNames(
    styles["divider-container"],
    styles[`divider-container--${lineStyleAsLowerCase}`]
  );
  const lineClassName = classNames(
    styles.divider,
    styles[`divider--${lineStyleAsLowerCase}`],
    styles[`divider--${width?.toLowerCase()}`],
    styles[`divider--${alignment?.toLowerCase()}`]
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className,
      "data-hook": `${ROOT} divider-${lineStyleAsLowerCase}`,
      role: "separator",
      "aria-orientation": "horizontal"
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.svgFixerContainer }, /* @__PURE__ */ React.createElement("svg", { className: lineClassName }, linesPropsArr.map((lineProp, i) => /* @__PURE__ */ React.createElement("line", { key: i, ...lineProp }))), /* @__PURE__ */ React.createElement("div", { className: styles.emptyChar }, " "))
  );
};
const lineProps = (lineDistance = 1) => ({
  x2: "100%",
  y1: lineDistance,
  y2: lineDistance
});
const getLines = (type) => {
  const linePropsArr = [lineProps()];
  if (type === "double") {
    linePropsArr.push(lineProps(7));
  }
  return linePropsArr;
};
export {
  DividerViewer
};
//# sourceMappingURL=divider-viewer.js.map
